<template>
  <div class="wrapper">
   <el-row :gutter="10">
     <el-col :span="8">
       <img :src="imageList[0]" alt="" srcset="">
     </el-col>
     <el-col :span="8">
       <img :src="imageList[1]" alt="" srcset="">
     </el-col>
     <el-col :span="8">
        <img :src="imageList[2]" alt="" srcset="">
     </el-col>
     <el-col :span="12">
       <img :src="imageList[3]" alt="" srcset="">
     </el-col>
     <el-col :span="12">
        <img :src="imageList[4]" alt="" srcset="">
     </el-col>
     <el-col class="tip-content">
       <p>
         Advance your career and life at Button Tech
       </p>
     </el-col>
   </el-row>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      imageRoot: process.env.VUE_APP_IMAGE_PATH
    }
  },
  computed: {
    imageList: function () {
      return [
        `${this.imageRoot}/social/explore2/ProductManager.png`,
        `${this.imageRoot}/social/explore2/team.png`,
        `${this.imageRoot}/social/explore2/MarketingManager.png`,
        `${this.imageRoot}/social/explore2/Designer.png`,
        `${this.imageRoot}/social/explore2/Engineer.png`
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-content{
  text-align: center;
  margin-top: 40px;
  p{
    font-size: 20px;
    color:#636363;
  }
}
.el-col{
  img{
    width:100%;
    position:relative;
    left:-10px;
    z-index:5;
    @include hoverAnimation(1.09);
    &:hover{
      z-index:10;
    }
  }
}
</style>
